"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSubtasksQuery = exports.fetchSubtaskQuery = exports.deleteSubtaskMutation = exports.updateSubtaskMutation = exports.createSubtaskMutation = exports.subtaskFragment = void 0;
const tslib_1 = require("tslib");
const Subtask_graphql_1 = tslib_1.__importDefault(require("./fragments/Subtask.graphql"));
exports.subtaskFragment = Subtask_graphql_1.default;
const createSubtask_graphql_1 = tslib_1.__importDefault(require("./mutation/createSubtask.graphql"));
exports.createSubtaskMutation = createSubtask_graphql_1.default;
const updateSubtask_graphql_1 = tslib_1.__importDefault(require("./mutation/updateSubtask.graphql"));
exports.updateSubtaskMutation = updateSubtask_graphql_1.default;
const deleteSubtask_graphql_1 = tslib_1.__importDefault(require("./mutation/deleteSubtask.graphql"));
exports.deleteSubtaskMutation = deleteSubtask_graphql_1.default;
const fetchSubtask_graphql_1 = tslib_1.__importDefault(require("./queries/fetchSubtask.graphql"));
exports.fetchSubtaskQuery = fetchSubtask_graphql_1.default;
const fetchSubtasks_graphql_1 = tslib_1.__importDefault(require("./queries/fetchSubtasks.graphql"));
exports.fetchSubtasksQuery = fetchSubtasks_graphql_1.default;
//# sourceMappingURL=index.js.map